

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class TipPool_ManagedObject

class TipPool_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: date
    set date(value:Date) {
        this.setValueForKey(value, 'date');
    }
    get date():Date {
        return this.valueForKey('date');
    }
    set datePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'date');
    }
    get datePrimitiveValue():Date {
        return this.primitiveValueForKey('date');
    }

    // Property: expectedValue
    set expectedValue(value:number) {
        this.setValueForKey(value, 'expectedValue');
    }
    get expectedValue():number {
        return this.valueForKey('expectedValue');
    }
    set expectedValuePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'expectedValue');
    }
    get expectedValuePrimitiveValue():number {
        return this.primitiveValueForKey('expectedValue');
    }

    // Property: value
    set value(value:number) {
        this.setValueForKey(value, 'value');
    }
    get value():number {
        return this.valueForKey('value');
    }
    set valuePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'value');
    }
    get valuePrimitiveValue():number {
        return this.primitiveValueForKey('value');
    }

    // Property: workerName
    set workerName(value:string) {
        this.setValueForKey(value, 'workerName');
    }
    get workerName():string {
        return this.valueForKey('workerName');
    }
    set workerNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'workerName');
    }
    get workerNamePrimitiveValue():string {
        return this.primitiveValueForKey('workerName');
    }
    // Relationship: worker
    set worker(value:Employee) {
        this.setValueForKey(value, 'worker');
    }
    get worker():Employee {
        return this.valueForKey('worker') as Employee;
    }
}
